/*
 *
 * ForgotPassword reducer
 *
 */
import { createSlice } from '@reduxjs/toolkit';

import { requestResetAct, resetRequestResetAct } from './actions';

export const initialState = {
  loadingState: 0,
};

/* eslint-disable default-case, no-param-reassign */
const forgotPasswordSlice = createSlice({
  name: 'ForgotPassword',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(requestResetAct, (state, { payload }) => {
        const { loadingState } = payload;
        state.loadingState = loadingState;
      })
      .addCase(resetRequestResetAct, () => initialState);
  },
});

export default forgotPasswordSlice.reducer;
